export const URLS = {
  SIGN_IN: '/login',
  SIGN_UP: 'sign-up',
  USER: 'user',
  CREATE_EVENT: 'create-event',
  GET_EVENTS: 'get-events',
  GET_RESULTS: 'ro-centers/',
  GET_DIVISIONS: '/divisions',
  GET_DASHBOARD_SUMMARY: '/division-summary',
  GET_DASHBOARD_DIVISIONS: '/division-election-setting',
  GET_SETTINGS_WISE_REPORT: '/settings-wise-report',
  GET_INITIAL_SETTINGS: '/division-initial-election-setting',
  GET_ELECTIONS: '/elections',
  GET_DASHBOARD_DIVISION_CENTERS: (divisionId: number, asonId: number) =>
    `/election-settings-total/${divisionId}/${asonId}`,
  GET_COUNTRY_REPORT: '/country-report',

  GET_INSTITUTES: 'get_institutes/',
  GET_ELECTION_SETTINGS: '/elections-settings',
  UPDATE_INSTITUTES: ({ uuid }: any) => `get_institutes/${uuid}/`,

  GET_CONSTITUENCY_WISE_RESULTS: ({
    division,
    timeSlot,
    percentage,
    election_schedule_id,
  }: {
    division: number | string;
    timeSlot: number | string;
    percentage: number | string;
    election_schedule_id: string | number;
  }) =>
    `/get-election-setting-time?division_id=${division}&time_range=${timeSlot}&percentage_threshold=${Number(
      percentage || 0,
    )}&election_schedule_id=${election_schedule_id}`,

  GET_CENTER_WISE_RESULTS: ({
    constituencyId,
    percentage,
    timeSlot,
    search,
    size,
    page,
    election_schedule_id,
  }: {
    constituencyId: number | string;
    percentage: number | string;
    timeSlot: number | string;
    search: number | string;
    size: number;
    page: number;
    election_schedule_id: string | number;
  }) =>
    `/center-wise-data?election_setting_id=${constituencyId}&time_range=${timeSlot}&page=${page}&page_size=${size}&center_name=${search}&percentage_threshold=${Number(
      percentage || 0,
    )}&election_schedule_id=${election_schedule_id}`,
};
